import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';

import { ScreenService } from 'app/shared/services';

@Component({
    selector: 'app-side-nav-outer-toolbar',
    templateUrl: './side-nav-outer-toolbar.component.html',
    styleUrls: ['./side-nav-outer-toolbar.component.scss'],
    standalone: false,
})
export class SideNavOuterToolbarComponent implements OnInit {
  @ViewChild('mainContent') mainContent!: ElementRef<HTMLElement>;

  menuOpened!: boolean;
  temporaryMenuOpened = false;

  @Input()
  title!: string;

  minMenuSize = 0;
  isXSmall = false;
  isLarge = false;

  constructor(private screen: ScreenService) {}

  ngOnInit() {
    this.menuOpened = this.screen.sizes['screen-large'];

    this.screen.changed.subscribe(() => this.updateLayout());
    this.updateLayout();
  }

  updateLayout() {
    this.isXSmall = this.screen.sizes['screen-x-small'];
    this.isLarge = this.screen.sizes['screen-large'];
    this.minMenuSize = this.isXSmall ? 0 : 60;
  }

  get hideMenuAfterNavigation() {
    return !this.isLarge || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  // skipcq: JS-0323
  navigationChanged(event: any) {
    if (this.hideMenuAfterNavigation) {
      this.temporaryMenuOpened = false;
      this.menuOpened = false;
    }

    // Scroll main content to top
    if (this.mainContent?.nativeElement) {
      this.mainContent.nativeElement.scrollTop = 0;
    }
  }

  navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      this.menuOpened = true;
    }
  }
}
